import script from "./HighRecommendItem.vue?vue&type=script&setup=true&lang=js"
export * from "./HighRecommendItem.vue?vue&type=script&setup=true&lang=js"

import "./HighRecommendItem.vue?vue&type=style&index=0&id=13dcf8c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13dcf8c0"]])

export default __exports__